import React from 'react';
const NoData = () => (
  <div className="flex flex-col items-center justify-center h-full text-gray-500">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-16 h-16 mb-4"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 10h18M3 14h18M5 4h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2z" />
    </svg>
    <p className="text-lg font-semibold">No Data Available</p>
    <p className="text-sm text-gray-400 text-center">It looks like there's no data to display at the moment.</p>
  </div>
);

export default NoData;

